import React from 'react';

import { FlexBox } from 'ml-rubiks-styleguide/src/box';

import { usePaymentErrorContext } from '../../contexts/payment-error-context';
import { PaymentMethodHeader } from '../payment-method-manager/payment-method-header';
import { UnifiedError } from './unified-error';

interface PaymentLayoutProps {
    title?: string;
    onBack?: () => void;
    onClose?: () => void;
    children?: React.ReactNode;
}

export const PaymentLayout: React.FC<PaymentLayoutProps> = ({
    title,
    onBack,
    onClose,
    children
}) => {
    const { state, clearErrors, hasExternalErrorHandler } =
        usePaymentErrorContext();

    const shouldShowErrors =
        state.errors.length > 0 &&
        !state.isDismissed &&
        !hasExternalErrorHandler;

    return (
        <FlexBox
            stack
            gap={2}
            sx={{ width: '100%', bgcolor: 'background.paper' }}
        >
            {(title || onBack || onClose) && (
                <PaymentMethodHeader
                    title={title}
                    onBack={onBack}
                    onClose={onClose}
                />
            )}

            {shouldShowErrors && (
                <UnifiedError
                    message={state.errors[0].message}
                    error={state.errors[0]}
                    dismissible={!state.isErrorBoundaryActive}
                    onDismiss={
                        state.isErrorBoundaryActive ? undefined : clearErrors
                    }
                />
            )}

            {!(state.isErrorBoundaryActive && shouldShowErrors) && children}
        </FlexBox>
    );
};
